import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    noContentElementInitialState,
    paginatedArrayContentElementInitialState,
    printInitialState,
    updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  consultationTransactionsList: { ...paginatedArrayContentElementInitialState },
  annulationTransaction: { ...noContentElementInitialState },
  print: {...printInitialState,
  },
};

/*-------------------------------------------------CONSULTATION-TRANSACTIONS----------------------------------------------------*/
const getConsultationTransactionsList = (state) => {
  return updateState("consultationTransactionsList", state, {
    ...paginatedArrayContentElementInitialState,
    isLoading: true,
  });
};

const getConsultationTransactionsListSuccess = (
  state,
  { content, totalElements }
) => {
  return updateState("consultationTransactionsList", state, {
    content,
    totalElements,
    isLoading: false,
    isSuccessed: true,
  });
};

const getConsultationTransactionsListFail = (state, payload) => {
  return updateState("consultationTransactionsList", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
/*-------------------------------------------------ANNULATION-TRANSACTION----------------------------------------------------*/
const annulationTransaction = (state) => {
  return updateState("annulationTransaction", state, {
    ...noContentElementInitialState,
    isLoading: true,
  });
};

const annulationTransactionSuccess = (state) => {
  return updateState("annulationTransaction", state, {
    isLoading: false,
    isSuccessed: true,
  });
};

const annulationTransactionFail = (state, payload) => {
  return updateState("annulationTransaction", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const annulationTransactionReinitialization = (state) => {
  return updateState("annulationTransaction", state, {
    ...noContentElementInitialState,
  });
};


/*---------------------------------excel----------------------------------*/
const print = (state) => {
  return updateState("print", state, {
    ...printInitialState,
    isLoading: true,
  });
};

const printSuccess = (state, { content, type, fileName }) => {
  return updateState("print", state, {
    content,
    type,
    fileName,
    isLoading: false,
    isSuccessed: true,
  });
};

const printFail = (state, payload) => {
  return updateState("print", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const printReinitialization = (state) => {
  return updateState("print", state, {
    ...printInitialState,
  });
};

/*************************************************************************** */
const consultationTransactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------CONSULTATION-TRANSACTIONS----------------------------------------------------*/
    case ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST:
      return getConsultationTransactionsList(state, action);
    case ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST_SUCCESS:
      return getConsultationTransactionsListSuccess(state, action.payload);
    case ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST_FAIL:
      return getConsultationTransactionsListFail(state, action.payload);
    /*-------------------------------------------------Excel----------------------------------------------------*/
    
    case ActionsTypes.GENERAL_EXCEL_EXPORT:
      return print(state, action.payload);
    case ActionsTypes.GENERAL_PRINT_SUCCESS:
      return printSuccess(state, action.payload);
    case ActionsTypes.GENERAL_PRINT_FAIL:
      return printFail(state);
    case ActionsTypes.GENERAL_PRINT_REINITIALIZATION:
      return printReinitialization(state);
    
    /*-------------------------------------------------ANNULATION-TRANSACTION----------------------------------------------------*/
    
    
    case ActionsTypes.ANNULATION_TRANSACTION:
      return annulationTransaction(state, action);
    case ActionsTypes.ANNULATION_TRANSACTION_SUCCESS:
      return annulationTransactionSuccess(state);
    case ActionsTypes.ANNULATION_TRANSACTION_FAIL:
      return annulationTransactionFail(state, action.payload);
    case ActionsTypes.ANNULATION_TRANSACTION_REINITIALIZATION:
      return annulationTransactionReinitialization(state, action.payload);
    default:
      return state;
  }
};

export default consultationTransactionsReducer;
